'use client';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getOptions, languages, fallbackLng } from './settings';

// Initialize i18next for client-side use
const initI18nextClient = (lng: string) => {
  i18n
    .use(initReactI18next)
    .use(resourcesToBackend((language: string, namespace: string) =>
      import(`./locales/${language}/${namespace}.json`)
    ))
    .init({
      ...getOptions(lng, 'common'),
      lng,
      preload: languages,
    });

  return i18n;
};

export { initI18nextClient };
export default i18n;
